
import specialTraining from './specialTraining'
import sportsHomework from './sportsHomework'
import classs from './classs'
import lessonResourceList from './lessonResourceList'

export default {
  classs,
  specialTraining, 
  sportsHomework,
  lessonResourceList,
}